module.exports = __webpack_public_path__ + "img/hands-heart.97bc2f33.jpg";